export default __webpack_public_path__ + "static/media/readysetreadyicontwo.b4cf36d9.png";